import { RecommendationGroupSummary } from '../../api/fundingApi'
import { FundingTodo } from '../../types'

/**
 * Collapse a recommendation group into the single-line ToDo the tile renders.
 * Returns null when the group lacks the action verb or a customer/opportunity
 * headline, so the caller can filter those out. Shared by the funding dashboard
 * and the Salesforce Canvas todos tile so both compose identical todo text.
 */
export const toTodo = (g: RecommendationGroupSummary): FundingTodo | null => {
  const action = g.action?.trim()
  const headline =
    g.sample?.[0]?.customer_name?.trim() ||
    g.sample?.[0]?.opportunity_id?.trim()
  if (!action || !headline) return null
  const others = g.count - 1
  const suffix =
    others <= 0
      ? '.'
      : others === 1
        ? ' and 1 other.'
        : ` and ${others} others.`
  return {
    id: g.group_id,
    text: `${action} for ${headline}${suffix}`,
    source: g.source,
  }
}
